import AOS from "aos";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import EmailSvg from "../assets/images/email_svg.svg";
import LocationSvg from "../assets/images/location_svg.svg";
import BiogiLogo from "../assets/images/ournewlogo.svg";
import PhoneSvg from "../assets/images/phone_svg.svg";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const date = new Date();
  const year = date.getFullYear();

  return (
    <>
      {/* <!-- ====================================== Footer ===================================== --> */}
      <footer>
        <div className="mobile-itemright-footer" data-aos="fade-down">
          <div className="footer-box-right">
            <p className="mind-project">Let’s bring your vision to life</p>
            <div className="view-work-circle btn btn1">
              <Link to="/contact" className="a1">
                LET'S TALK
              </Link>
            </div>
            <div>
              <p className="contact_time">09:00 AM – 10:30 PM</p>
              <p className="monday">Monday to Saturday</p>
            </div>
          </div>
        </div>

        <div className="footer-bg">
          <div className="container footer-containe">
            <div className="hekl">
              <div className="row">
                <div className="col-xxl-5 col-xl-5 col-lg-5">
                  <Link to="/" className="biogi-logo">
                    <img
                      src={BiogiLogo}
                      alt="Marichi Tech AI Logo"
                      width={90}
                      height={70}
                      style={{ transform: "scale(2.5)" }}
                    />
                  </Link>
                  <p className="work_well">
                    We craft innovative digital solutions to help your business
                    grow smarter and faster. Let’s build something extraordinary
                    together.
                  </p>
                  <div className="contact-footer">
                    <img src={PhoneSvg} alt="phone_svg" />
                    <Link to="tel:+9779840540455">+977 9840540455</Link>
                  </div>
                  <div className="contact-footer">
                    <img src={EmailSvg} alt="email_svg" />
                    <Link to="mailto:info@marichitechai.com">
                      info@marichitechai.com
                    </Link>
                  </div>
                  <div className="contact-footer">
                    <img src={LocationSvg} alt="location_svg" />
                    <p>Lazimpat, Kathmandu, Nepal</p>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-3"></div>

                <div className="col-xxl-3 col-xl-4 col-lg-4">
                  <p className="useful-link">USEFUL LINKS</p>
                  <div className="contact-footer">
                    <Link to="/about">About Us</Link>
                  </div>
                  <div className="contact-footer">
                    <Link to="/services">Our Services</Link>
                  </div>
                  <div className="contact-footer">
                    <Link to="/portfolio">Portfolio</Link>
                  </div>
                  <div className="contact-footer">
                    <Link to="/blog">Blog</Link>
                  </div>
                </div>
              </div>

              <div className="copyright_main">
                <p
                  className="copyright"
                  style={{
                    textWrap: "nowrap",
                  }}
                >
                  © {year} Marichi Tech AI. All rights reserved.
                </p>
              </div>
            </div>

            <div className="desktop-itemright-footer">
              <div className="footer-box-right">
                <p className="mind-project">Have a project in mind?</p>
                <div className="view-work-circle btn btn1">
                  <Link to="/contact" className="a1">
                    GET STARTED
                  </Link>
                </div>
                <div>
                  <p className="contact_time">09:00 AM – 6:00 PM</p>
                  <p className="monday">Monday to Friday</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- ====================================== Footer End ===================================== --> */}
    </>
  );
};

export default Footer;
